import { useSEO, generateWebPageSchema, generateBreadcrumbSchema, generateServiceSchema } from '@/utils/seo';
import ServicePageLayout, { ServicePageConfig } from '@/pages/service-common/ServicePageLayout';

/* ─── Hero Background ─── */
const HERO_IMG = 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20golden%20customer%20relationship%20network%20and%20connected%20user%20icons%20on%20deep%20navy%20blue%20background%20minimal%20sophisticated%20high-end%20corporate%20aesthetic%20soft%20glowing%20particles%20no%20text&width=1920&height=800&seq=crmhero1&orientation=landscape';

const config: ServicePageConfig = {
  pageLabel: 'CRMコンサルティング',
  heroImage: HERO_IMG,
  tag: 'CRM Consulting',
  title: <>顧客関係管理の<br />戦略的最適化</>,
  subtitle: 'CRMシステムの選定・導入から戦略設計・運用最適化まで。顧客との強固な関係を構築し、LTV向上と安定的な収益成長を実現します。',
  icon: 'ri-customer-service-2-line',
  services: [
    { icon: 'ri-map-pin-user-line', title: 'CRM戦略設計', desc: '顧客中心の戦略とプロセスを設計。LTV最大化に向けた包括的なCRM戦略を策定します。' },
    { icon: 'ri-settings-4-line', title: 'システム選定・導入', desc: '貴社に最適なCRMプラットフォームを選定し、スムーズな導入をサポートします。' },
    { icon: 'ri-database-2-line', title: 'データ統合', desc: 'すべてのタッチポイントの顧客データを統合し、360度の顧客ビューを実現します。' },
    { icon: 'ri-flow-chart', title: 'プロセス最適化', desc: '顧客対応ワークフローを効率化し、対応品質と速度を同時に向上させます。' },
    { icon: 'ri-group-line', title: 'トレーニング・定着支援', desc: 'ユーザー教育と変革管理で、CRM活用の定着化と継続的な効果創出を支援します。' },
    { icon: 'ri-bar-chart-box-line', title: 'アナリティクス・インサイト', desc: '顧客データを活用した高度な分析で、意思決定の精度を高めます。' },
  ],
  stats: [
    { number: '133+', label: '支援プロジェクト数' },
    { number: '3x', label: '平均LTV向上率' },
    { number: '40%', label: '営業効率改善' },
    { number: '95%', label: '顧客満足度' },
  ],
  benefits: [
    '顧客満足度とロイヤルティの向上による安定した収益基盤を構築',
    '営業効率と成約率の向上で、限られたリソースで最大の成果を実現',
    'すべての顧客接点を可視化し、一貫した顧客体験を提供',
    'ルーティンタスクを自動化し、高付加価値業務に集中できる環境を実現',
    'データドリブンな意思決定により、施策の精度と効果を継続的に向上',
    '業種・規模を問わず、貴社の状況に最適化されたCRM戦略を提供',
  ],
};

export default function CRMConsultingPage() {
  useSEO({
    title: '東京 CRMコンサルティング TradFit株式会社 | 顧客関係管理戦略',
    description: 'TradFit株式会社のCRMコンサルティングサービス。CRMシステムの選定・導入から戦略設計・運用最適化まで、顧客との強固な関係を構築します。',
    keywords: 'CRMコンサルティング, 顧客関係管理, LTV向上, 東京',
    path: '/crm-consulting',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        generateWebPageSchema('CRMコンサルティング | TradFit株式会社', 'TradFit株式会社のCRMコンサルティングサービス。', '/crm-consulting'),
        generateBreadcrumbSchema([{ name: 'ホーム', path: '/' }, { name: '事業内容', path: '/business' }, { name: 'CRMコンサルティング', path: '/crm-consulting' }]),
        generateServiceSchema('CRMコンサルティング', 'CRMシステムの選定・導入から戦略設計・運用最適化までのCRMコンサルティングサービス。'),
      ],
    },
  });
  return <ServicePageLayout config={config} />;
}
